import React, { useEffect, useRef, useState } from 'react';
import { loadStaticSpritePreviewFrame } from '../../../../sprites/spriteAssembler';

interface Props {
  filename: string;
  size?: number;
}

export const StaticSpritePreview: React.FC<Props> = ({ filename, size = 200 }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoaded(false);
    setError(false);

    console.debug('[StaticSpritePreview] Loading static sprite:', filename);
    loadStaticSpritePreviewFrame(filename)
      .then(frame => {
        if (cancelled) { frame.close(); return; }
        const canvas = canvasRef.current;
        if (canvas) {
          canvas.width = frame.width;
          canvas.height = frame.height;
          canvas.getContext('2d')!.drawImage(frame, 0, 0);
          setLoaded(true);
          console.debug('[StaticSpritePreview] Loaded static sprite successfully:', filename);
        }
        frame.close();
      })
      .catch(err => {
        if (!cancelled) {
          console.warn('[StaticSpritePreview] Failed to load:', filename, err);
          setError(true);
        }
      });
    return () => { cancelled = true; };
  }, [filename]);

  return (
    <div style={{
      width: size,
      height: size,
      background: '#0d0d1a',
      border: '1px solid #444',
      borderRadius: 6,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      overflow: 'hidden',
    }}>
      <canvas
        ref={canvasRef}
        style={{
          imageRendering: 'pixelated',
          maxWidth: '100%',
          maxHeight: '100%',
          display: loaded ? 'block' : 'none',
        }}
      />
      {!loaded && (
        <span style={{ color: error ? '#663333' : '#555', fontSize: 12 }}>
          {error ? '!' : '…'}
        </span>
      )}
    </div>
  );
};
